import React, { useEffect } from 'react';
import { connect } from "react-redux";
import './DlUnitEdit.scss';
import { Form, Button } from 'react-bootstrap';
import { getSer, newSerInit, saveSer, getGroupLi } from "./../../actions";
import PhotoSer from '../../models/PhotoSer';
import AdmPhSerSingleNav from './AdmPhSerSingleNav';

const mapStateToProps = (state) => ({
    phSSer: state.phSer.phSSer,
    dlGroupN: state.dlGroupLi.dlGroupN,
});

const mapDispatchToProps = (dispatch) => ({
    getSer: (payload) => dispatch(getSer(payload)),
    newSerInit: () => dispatch(newSerInit()),
    saveSer: (payload) => dispatch(saveSer(payload)),  
    getGroupLi: (payload) => dispatch(getGroupLi(payload)),  
    
});

const AdmPhotoSerEdit = ({ match, phSSer, getSer, newSerInit, saveSer, dlGroupN, getGroupLi }) => {
    const itemId = ( 'itemId' in match.params ? match.params.itemId : '' );
    let rSlug = React.createRef();
    let rName = React.createRef();
    let rDesc = React.createRef();
    let rGroup = React.createRef();
    let rSType = React.createRef();

    // getGroupLi();

    useEffect(function() {
        if (itemId!=='') {
            getSer({'_id': itemId});
            getGroupLi();
        } else {
            newSerInit();
        }
    }, [itemId]);

    const saveItem = (ev) => {
        let item = new PhotoSer();
        item.obSet({ 
            slug: rSlug.current.value, 
            name: rName.current.value, 
            desc: rDesc.current.value, 
            group: rGroup.current.value, 
            sType: rSType.current.value, 
        });
        // ev.preventDefault();
        saveSer({ itemId: phSSer.id, item });
    };

    const groupLi = dlGroupN.map((group, ind) => {
        const gNam = group.slug.replace(/\-/g, ' ');
        return <option key={ind} value={ group.slug } selected={ phSSer.group == group.slug }>{ gNam }</option>
        ;
    });

    return (
        <Form style={{ 'marginLeft': '0%' }} onSubmit={saveItem}>
            <AdmPhSerSingleNav item={ phSSer } />
            <Form.Group style={{ marginTop: '1em' }}>
                <Form.Label>Slug</Form.Label>
                <Form.Control type="text" ref={rSlug} defaultValue={phSSer.slug} />
            </Form.Group>
            <Form.Group>
                <Form.Label>Tip</Form.Label>
                <Form.Control as="select" ref={rSType} defaultValue={phSSer.sType} style={{ minHeight: '2.5em' }}>
                    <option defaultValue="fotografije" selected={ phSSer.sType == 'fotografije' }>fotografije</option>
                    <option defaultValue="neknjizna_gradja" selected={ phSSer.sType == 'neknjizna_gradja' }>neknjizna gradja</option>
                </Form.Control>
            </Form.Group>
            <Form.Group>
                <Form.Label>Naziv</Form.Label>
                <Form.Control type="text" ref={rName} defaultValue={phSSer.name} />
            </Form.Group>
            <Form.Group>
                <Form.Label>Opis</Form.Label>
                <Form.Control type="text" ref={rDesc} defaultValue={phSSer.desc} />
            </Form.Group>
            <Form.Group>
                <Form.Label>Odrednica</Form.Label>
                <Form.Control as="select" ref={rGroup} defaultValue={phSSer.group} style={{ minHeight: '2.5em' }}>
                    {groupLi}
                </Form.Control>
            </Form.Group>
            <Button variant="primary" type="button" onClick={saveItem} style={{ marginTop: '1em' }}>
            OK
            </Button>
        </Form>

    );

}

export default connect(mapStateToProps, mapDispatchToProps)(AdmPhotoSerEdit);
